export class Paths {
  public static readonly LOGIN = '';
  public static readonly HOME = 'home';
  public static readonly EMPTY = 'empty';
  public static readonly DASHBOARD = 'dashboards';
  public static readonly CHARTS = 'charts';
  public static readonly REPORTS = 'reports';
  public static readonly PARTITIONS = 'partitions';
  public static readonly USERS = 'users';
  public static readonly DEVICE_TYPES = 'device_types';
  public static readonly GATEWAYS = 'gateways';
  public static readonly GATEWAY_TYPES = 'gateway_types';
  public static readonly DIAGNOSTICS = 'diagnostic';
  public static readonly ALERTS = 'alert';
  public static readonly VIRTUAL_METRICS = 'virtual_metrics';

  public static readonly RESET_PASSWORD = 'resetPassword';
}
